export const MULTILANGUAGE = {
    'en': {
        englishName: 'English',
        name: 'English',
        value: 'en',
    },
    'ko': {
        englishName: 'Korean',
        name: '한국어',
        value: 'ko',
    },
    'ja': {
        englishName: 'Japanese',
        name: '日本語',
        value: 'ja',
    },
    'zh-HK': {
        englishName: 'Chinese (Traditional)',
        name: '繁體中文',
        value: 'zh-HK',
    },
    'zh-CN': {
        englishName: 'Chinese (Simplified)',
        name: '简体中文',
        value: 'zh-CN',
    },
    'id': {
        englishName: 'Indonesian',
        name: 'Bahasa Indonesia',
        value: 'id',
    },
    'th': {
        englishName: 'Thai',
        name: 'แบบไทย',
        value: 'th',
    },
    'vi': {
        englishName: 'Vietnamese',
        name: 'Tiếng Việt',
        value: 'vi',
    },
};
